/* Freya Gurme — product rendering: art-directed visuals, cards, grid,
   filters, featured strip, product detail modal. Photo-swap aware:
   if images/products/{slug}.jpg loads, it fades over the gradient. */
(function () {
  "use strict";

  var P = window.FREYA_PRODUCTS || [];
  var CATS = window.FREYA_CATEGORIES || {};

  function fmtPrice(p) {
    var v = p.price != null ? p.price : p.priceFrom;
    var str = new Intl.NumberFormat("tr-TR").format(v) + " ₺";
    return p.price != null ? str : str + "’den";
  }

  function visual(p, opts) {
    opts = opts || {};
    var h = p.hue || ["#B98A3E", "#7A4F12"];
    var mono = opts.big ? "font-size:7rem" : "font-size:2.6rem";
    var nameSize = opts.big ? "1.2rem" : "0.78rem";
    return (
      '<div class="pv h-full w-full" style="background:radial-gradient(120% 90% at 50% 0%, ' +
      h[0] + " 0%, " + h[1] + ' 80%)">' +
      '<span class="pv__bloom"></span>' +
      '<div class="pv__jar" aria-hidden="true">' +
      '<span class="pv__mono" style="' + mono + '">F</span>' +
      '<span class="pv__name" style="font-size:' + nameSize + '">' + esc(p.name) + "</span>" +
      '<span class="pv__tag">Freya Gurme</span>' +
      "</div>" +
      '<span class="pv__grain"></span>' +
      '<img class="pv__photo" data-view="0" alt="' + esc(p.name) + ' — ön yüz" draggable="false" loading="lazy" data-photo="images/products/' + p.slug + '" data-source="' + esc(p.image || '') + '">' +
      (p.backImage ? '<img class="pv__photo" data-view="1" aria-hidden="true" alt="' + esc(p.name) + ' — arka yüz" draggable="false" loading="lazy" data-photo="" data-source="' + esc(p.backImage) + '">' : '') +
      "</div>"
    );
  }

  function badges(p) {
    return (p.tags || [])
      .slice(0, 3)
      .map(function (t) {
        return (
          '<span class="rounded-full border border-cream-200 bg-cream-50 px-2.5 py-1 text-[0.68rem] font-medium text-stone-500">' +
          esc(t) +
          "</span>"
        );
      })
      .join("");
  }

  function gallery(p, opts) {
    opts = opts || {};
    var cat = CATS[p.cat] || { label: "", color: "#9A5F1C" };
    var stage = opts.big ? 'div' : 'button';
    return '<div class="product-gallery' + (opts.big ? ' product-gallery--detail' : '') + '" data-view="0"' +
      (p.backImage ? ' data-multi="true"' : '') + ' role="group" aria-label="' + esc(p.name) + ' fotoğrafları">' +
      '<' + stage + ' class="product-gallery-stage' + (opts.big ? '' : ' js-open') + '"' +
      (opts.big ? '' : ' type="button" aria-label="' + esc(p.name) + ' detayları"') + '>' + visual(p, opts) +
      (!opts.big ? '<span class="gallery-category" style="background:' + cat.color + '">' + esc(cat.label) + '</span>' +
        (p.stock === false ? '<span class="gallery-stock">Tükendi</span>' : '') : '') +
      '</' + stage + '>' +
      (p.backImage ? '<div class="gallery-controls">' +
        '<button type="button" class="gallery-arrow" data-gallery-step="-1" aria-label="Önceki fotoğraf" disabled><span aria-hidden="true">←</span></button>' +
        '<div class="gallery-views">' +
        '<button type="button" data-gallery-view="0" aria-pressed="true">Ön yüz</button>' +
        '<button type="button" data-gallery-view="1" aria-pressed="false" disabled>Arka yüz</button></div>' +
        '<button type="button" class="gallery-arrow" data-gallery-step="1" aria-label="Sonraki fotoğraf" disabled><span aria-hidden="true">→</span></button>' +
        '</div><p class="gallery-status sr-only" role="status" aria-live="polite"></p>' : '') + '</div>';
  }

  function card(p) {
    return (
      '<article class="product-card group flex flex-col overflow-hidden rounded-lg border border-cream-200 bg-cream-50 shadow-soft transition-all duration-300 hover:-translate-y-1 hover:shadow-card" ' +
      'data-cat="' + p.cat + '" data-slug="' + p.slug + '">' +
      gallery(p) +
      '<div class="flex flex-1 flex-col p-5">' +
      '<h3 class="font-display text-h3 font-semibold text-ink">' + esc(p.name) + "</h3>" +
      (p.sizes ? '<p class="product-sizes">' + esc(p.sizes) + '</p>' : '') +
      '<p class="mt-2 flex-1 text-sm leading-relaxed text-stone-500">' + esc(p.short) + "</p>" +
      '<div class="mt-4 flex flex-wrap gap-1.5">' + badges(p) + "</div>" +
      '<div class="mt-5 flex items-center justify-between gap-3">' +
      '<span class="font-display text-h2 font-semibold text-ink">' + fmtPrice(p) + "</span>" +
      '<button type="button" class="js-open inline-flex items-center gap-1.5 rounded-md bg-ink px-3.5 py-2 text-sm font-semibold text-cream-50 transition-colors duration-200 hover:bg-gold-deep">İncele' +
      '<svg class="h-3.5 w-3.5" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="2"><path d="M7 5l5 5-5 5" stroke-linecap="round" stroke-linejoin="round"/></svg></button>' +
      "</div></div></article>"
    );
  }

  function esc(s) {
    return String(s == null ? "" : s)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }

  // One shared visual keeps the same pointer depth on either photograph.
  function bindGalleries(root) {
    root.querySelectorAll('.product-gallery[data-multi]').forEach(function (gallery) {
      if (gallery.dataset.bound) return;
      gallery.dataset.bound = '1';
      var stage = gallery.querySelector('.product-gallery-stage');
      var status = gallery.querySelector('.gallery-status');
      var ready = false, current = 0, start = null, suppressClick = false;
      function show(index) {
        if (!ready) return;
        current = (index + 2) % 2;
        gallery.dataset.view = String(current);
        gallery.querySelectorAll('.pv__photo[data-view]').forEach(function (photo) {
          photo.setAttribute('aria-hidden', String(Number(photo.dataset.view) !== current));
        });
        gallery.querySelectorAll('[data-gallery-view]').forEach(function (button) {
          button.setAttribute('aria-pressed', String(Number(button.dataset.galleryView) === current));
        });
        status.textContent = current ? 'Arka yüz · 2 / 2' : 'Ön yüz · 1 / 2';
      }
      gallery.addEventListener('photo-ready', function () {
        ready = gallery.querySelectorAll('.pv__photo.is-loaded').length === 2;
        if (ready) gallery.querySelectorAll('.gallery-controls button').forEach(function (button) { button.disabled = false; });
      });
      gallery.addEventListener('photo-error', function () {
        status.classList.remove('sr-only');
        status.textContent = 'Fotoğraf yüklenemedi. Lütfen sayfayı yenileyin.';
      });
      gallery.querySelectorAll('[data-gallery-view]').forEach(function (button) {
        button.addEventListener('click', function () { show(Number(button.dataset.galleryView)); });
      });
      gallery.querySelectorAll('[data-gallery-step]').forEach(function (button) {
        button.addEventListener('click', function () { show(current + Number(button.dataset.galleryStep)); });
      });
      gallery.addEventListener('keydown', function (event) {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        show(current + (event.key === 'ArrowRight' ? 1 : -1));
      });
      // Preserve vertical page scrolling; a horizontal drag changes the view.
      stage.addEventListener('pointerdown', function (event) {
        if (!ready || !event.isPrimary || event.button !== 0) return;
        suppressClick = false;
        start = {x:event.clientX, y:event.clientY, id:event.pointerId, horizontal:false};
      });
      stage.addEventListener('pointermove', function (event) {
        if (!start || event.pointerId !== start.id) return;
        var dx = event.clientX - start.x, dy = event.clientY - start.y;
        if (!start.horizontal && Math.abs(dy) > 14 && Math.abs(dy) > Math.abs(dx)) { start = null; return; }
        if (Math.abs(dx) > 12 && Math.abs(dx) > Math.abs(dy) * 1.3) {
          start.horizontal = true;
          suppressClick = true;
          stage.setPointerCapture(event.pointerId);
        }
      });
      stage.addEventListener('pointerup', function (event) {
        if (!start || event.pointerId !== start.id) return;
        var dx = event.clientX - start.x;
        if (start.horizontal && Math.abs(dx) > 40) show(current + (dx < 0 ? 1 : -1));
        start = null;
        if (stage.hasPointerCapture(event.pointerId)) stage.releasePointerCapture(event.pointerId);
      });
      stage.addEventListener('pointercancel', function () { start = null; });
      stage.addEventListener('pointerleave', function () { if (start && !start.horizontal) start = null; });
      stage.addEventListener('click', function (event) {
        if (suppressClick && event.detail !== 0) {
          event.preventDefault(); event.stopImmediatePropagation(); suppressClick = false;
        }
      }, true);
    });
  }

  // ---- Photo swap ----
  // Looks for images/products/{slug}.{jpg|png|webp|jpeg}; first that loads
  // fades in over the art-directed gradient.
  var PHOTO_EXT = ["jpg", "png", "webp", "jpeg"];
  // Pointer-driven depth: use the stable outer frame for coordinates.
  var motionAllowed = window.matchMedia("(hover: hover) and (pointer: fine) and (prefers-reduced-motion: no-preference)");
  function bindProductDepth(root) {
    root.querySelectorAll(".pv").forEach(function (visual) {
      if (visual.dataset.depthBound) return;
      visual.dataset.depthBound = "1";
      visual.classList.add("product-depth");
      var frame = visual.closest(".product-gallery-stage") || visual.closest(".js-open") || visual.parentElement;
      var pending = 0, x = 0, y = 0;
      function reset() {
        cancelAnimationFrame(pending); pending = 0;
        visual.classList.remove("is-tilting");
        ["--tilt-x", "--tilt-y", "--shift-x", "--shift-y", "--light-x", "--light-y"].forEach(function (key) { visual.style.removeProperty(key); });
      }
      frame.addEventListener("pointermove", function (event) {
        if (!motionAllowed.matches || event.pointerType === "touch") { reset(); return; }
        var rect = frame.getBoundingClientRect();
        x = Math.max(-1, Math.min(1, (event.clientX - rect.left) / rect.width * 2 - 1));
        y = Math.max(-1, Math.min(1, (event.clientY - rect.top) / rect.height * 2 - 1));
        if (pending) return;
        pending = requestAnimationFrame(function () {
          pending = 0;
          visual.classList.add("is-tilting");
          visual.style.setProperty("--tilt-x", (-y * 7).toFixed(2) + "deg");
          visual.style.setProperty("--tilt-y", (x * 9).toFixed(2) + "deg");
          visual.style.setProperty("--shift-x", (x * 7).toFixed(2) + "px");
          visual.style.setProperty("--shift-y", (y * 5).toFixed(2) + "px");
          visual.style.setProperty("--light-x", (50 + x * 40) + "%");
          visual.style.setProperty("--light-y", (50 + y * 40) + "%");
        });
      }, {passive:true});
      frame.addEventListener("pointerleave", reset);
      frame.addEventListener("pointercancel", reset);
      frame.addEventListener("focusout", reset);
    });
  }

  function swapPhotos(root) {
    bindGalleries(root || document);
    bindProductDepth(root || document);
    (root || document).querySelectorAll("img.pv__photo[data-photo]").forEach(function (img) {
      if (img.dataset.tried) return;
      img.dataset.tried = "1";
      var base = img.getAttribute("data-photo");
      var sources = img.dataset.source ? [img.dataset.source] : PHOTO_EXT.map(function (ext) { return base + "." + ext; });
      var i = 0;
      (function attempt() {
        if (i >= sources.length) {
          var gallery = img.closest('.product-gallery');
          if (gallery) gallery.dispatchEvent(new Event('photo-error'));
          return; // Keep the current photograph or fallback.
        }
        var src = sources[i++];
        var probe = new Image();
        probe.onload = function () {
          img.src = src;
          img.classList.add("is-loaded");
          var jar = img.parentElement.querySelector(".pv__jar");
          if (jar && img.dataset.view === '0') jar.style.opacity = "0";
          var gallery = img.closest('.product-gallery');
          if (gallery) gallery.dispatchEvent(new Event('photo-ready'));
        };
        probe.onerror = attempt;
        probe.src = src;
      })();
    });
  }

  // ---- Detail modal ----
  var modal, previousFocus;
  function ensureModal() {
    if (modal) return modal;
    modal = document.createElement("div");
    modal.id = "pmodal";
    modal.className =
      "fixed inset-0 z-[60] hidden items-end justify-center bg-ink/55 backdrop-blur-sm p-0 md:items-center md:p-6";
    modal.innerHTML = '<div id="pmodal-panel" class="relative w-full max-w-3xl max-h-[92vh] overflow-y-auto rounded-t-xl bg-cream-50 shadow-lift md:rounded-xl"></div>';
    modal.setAttribute("role", "dialog");
    modal.setAttribute("aria-modal", "true");
    modal.setAttribute("aria-label", "Ürün bilgileri");
    document.body.appendChild(modal);
    modal.addEventListener("click", function (e) {
      if (e.target === modal) close();
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") close();
      if (e.key === "Tab" && modal && !modal.classList.contains("hidden")) {
        var nodes = Array.from(modal.querySelectorAll("button:not([disabled]), a[href], select:not([disabled])")).filter(function(node){return node.getClientRects().length && !node.closest("[hidden]");});
        var first = nodes[0], last = nodes[nodes.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });
    return modal;
  }

  function openDetail(slug) {
    var p = P.find(function (x) { return x.slug === slug; });
    if (!p) return;
    var cat = CATS[p.cat] || { label: "", color: "#9A5F1C" };
    previousFocus = document.activeElement;
    ensureModal();
    var panel = document.getElementById("pmodal-panel");
    var wa =
      "https://wa.me/" + (window.FREYA_SHELL ? window.FREYA_SHELL.WA : "905322523555") +
      "?text=" +
      encodeURIComponent('Merhaba Freya Gurme! "' + p.name + "\" hakkında bilgi almak istiyorum.");

    panel.innerHTML =
      '<button type="button" id="pmodal-close" aria-label="Kapat" class="absolute right-3 top-3 z-10 flex h-10 w-10 items-center justify-center rounded-full bg-cream-50/90 text-ink shadow-soft transition hover:bg-cream-100">' +
      '<svg class="h-5 w-5" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="2"><path d="M5 5l10 10M15 5L5 15" stroke-linecap="round"/></svg></button>' +
      '<div class="grid md:grid-cols-2">' +
      gallery(p, { big: true }) +
      '<div class="p-7 md:p-9">' +
      '<span class="inline-block rounded-full px-3 py-1 text-[0.68rem] font-semibold uppercase tracking-[0.08em] text-cream-50" style="background:' + cat.color + '">' + esc(cat.label) + "</span>" +
      '<h2 class="mt-4 font-display text-h1 font-semibold text-ink">' + esc(p.name) + "</h2>" +
      '<p id="variant-price" class="mt-1 font-display text-h2 font-semibold text-gold-deep" aria-live="polite">' + fmtPrice(p) + '</p>' +
      variantPicker(p) +
      '<p class="mt-5 text-base leading-relaxed text-stone-600">' + esc(p.long) + "</p>" +
      detailRow("İçindekiler", p.ingredients) +
      detailRow("Kullanım önerisi", p.usage) +
      detailRow("Besin değerleri", p.nutrition) +
      '<div class="mt-5 flex flex-wrap gap-1.5">' + badges(p) + "</div>" +
      '<form id="quick-add" action="/cart/add" method="post" class="freya-buy-form"><input type="hidden" name="id"><input type="hidden" name="quantity" value="1"><input type="hidden" name="return_to" value="/cart"><button type="submit" class="button" id="quick-add-button">Sepete ekle</button><p class="freya-cart-status" role="status"></p></form>' +
      '<a class="text-link" href="' + esc(p.url) + '">' + (p.handle==='mini-sos-kutusu'?'4 sosunu seç':'Ürünün tüm detayları') + ' ↗</a>' +
      "</div></div>";

    bindVariants(p, panel);
    document.getElementById("pmodal-close").addEventListener("click", close);
    modal.classList.remove("hidden");
    modal.classList.add("flex");
    document.body.style.overflow = "hidden";
    document.querySelectorAll("#site-header,#main,#site-footer,#wa-fab,.freya-service-footer").forEach(function(el){el.inert=true;});
    swapPhotos(panel);
    document.getElementById("pmodal-close").focus();
  }

  function variantPicker(p) {
    if (!p.variants || !p.variants.length) return "";
    var options = p.variants.map(function (v, i) {
      return '<option value="' + i + '">' + esc(v.label) + ' — ' + fmtPrice({price:v.price}) + (v.available ? '' : ' · Tükendi') + '</option>';
    }).join('');
    return (p.variants.length > 1 ? '<div class="variant-picker"><label for="product-variant">' + (p.cat === 'hediye' ? 'Tutar seçin' : 'Boy seçin') + '</label><select id="product-variant">' + options + '</select></div>' : (p.sizes ? '<p class="product-sizes">' + esc(p.sizes) + '</p>' : '')) + '<p id="variant-stock" class="variant-stock" role="status"></p>';
  }

  function bindVariants(p, panel) {
    if (!p.variants || !p.variants.length) return;
    var select = panel.querySelector('#product-variant');
    var initial = p.variants.findIndex(function (v) { return v.available; });
    if (initial < 0) initial = 0;
    if (select) select.value = String(initial);
    function update() {
      var v = p.variants[select ? Number(select.value) : initial];
      panel.querySelector('#variant-price').textContent = fmtPrice({price:v.price});
      panel.querySelector('#variant-stock').textContent = v.available ? 'Stokta' : 'Bu seçenek şu anda tükendi.';
      panel.querySelector('#quick-add').hidden=p.handle==='mini-sos-kutusu';
      panel.querySelector('#quick-add [name="id"]').value=v.id;
      panel.querySelector('#quick-add-button').disabled=!v.available;
      panel.querySelector('#quick-add-button').textContent=v.available?'Sepete ekle':'Tükendi';
    }
    if (select) select.addEventListener('change', update);
    update();
  }

  function detailRow(label, val) {
    if (!val || val === "—") return "";
    return (
      '<div class="mt-5 border-t border-cream-200 pt-4">' +
      '<p class="text-label font-semibold uppercase tracking-[0.12em] text-gold-deep">' + esc(label) + "</p>" +
      '<p class="mt-1.5 text-sm leading-relaxed text-stone-600">' + esc(val) + "</p></div>"
    );
  }

  function close() {
    if (!modal || modal.classList.contains("hidden")) return;
    modal.classList.add("hidden");
    modal.classList.remove("flex");
    document.body.style.overflow = "";
    document.querySelectorAll("#site-header,#main,#site-footer,#wa-fab,.freya-service-footer").forEach(function(el){el.inert=false;});
    if (previousFocus) previousFocus.focus();
  }

  function bindCardClicks(root) {
    root.querySelectorAll("[data-slug]").forEach(function (artEl) {
      var slug = artEl.getAttribute("data-slug");
      artEl.querySelectorAll(".js-open").forEach(function (btn) {
        btn.addEventListener("click", function () { openDetail(slug); });
      });
    });
  }

  // ---- Mount points ----
  function renderFeatured() {
    var host = document.getElementById("featured-grid");
    if (!host) return;
    var picks = ["ejder-meyvesi-sosu", "hindistan-cevizi-granola", "aci-biberli-zeytinyagi"]
      .map(function (s) { return P.find(function (p) { return p.slug === s; }); })
      .filter(Boolean);
    host.innerHTML = picks
      .map(function (p, i) {
        return '<div class="reveal" style="transition-delay:' + i * 90 + 'ms">' + card(p) + "</div>";
      })
      .join("");
    bindCardClicks(host);
    swapPhotos(host);
  }

  function renderCatalog() {
    var host = document.getElementById("catalog-grid");
    if (!host) return;

    var collectionHandles=window.FREYA_SHOP?.collectionProducts;
    var catalogProducts=Array.isArray(collectionHandles)?P.filter(function(p){return collectionHandles.includes(p.handle);}):P;
    function draw(filter) {
      var list = filter === "all" ? catalogProducts : catalogProducts.filter(function (p) { return p.cat === filter; });
      host.innerHTML = list
        .map(function (p, i) {
          return '<div class="reveal is-visible" style="transition-delay:' + (i % 3) * 70 + 'ms">' + card(p) + "</div>";
        })
        .join("");
      bindCardClicks(host);
      swapPhotos(host);
      var countEl = document.getElementById("catalog-count");
      if (countEl) countEl.textContent = list.length + " ürün";
    }

    var bar = document.getElementById("catalog-filters");
    if (bar) {
      var tabs = [{ key: "all", label: "Tümü" }].concat(
        Object.keys(CATS).filter(function(k){return catalogProducts.some(function(p){return p.cat===k;});}).map(function (k) { return { key: k, label: CATS[k].label }; })
      );
      bar.innerHTML = tabs
        .map(function (t, i) {
          var active = i === 0;
          return (
            '<button type="button" data-filter="' + t.key + '" aria-pressed="' + active + '" ' +
            'class="filter-tab rounded-full border px-5 py-2 text-sm font-semibold transition-colors duration-200 ' +
            (active ? "border-gold-deep bg-gold-deep text-cream-50" : "border-cream-200 bg-cream-50 text-stone-500 hover:border-sand-300 hover:text-ink") +
            '">' + t.label + "</button>"
          );
        })
        .join("");
      bar.addEventListener("click", function (e) {
        var btn = e.target.closest(".filter-tab");
        if (!btn) return;
        bar.querySelectorAll(".filter-tab").forEach(function (b) {
          b.setAttribute("aria-pressed", "false");
          b.className = "filter-tab rounded-full border px-5 py-2 text-sm font-semibold transition-colors duration-200 border-cream-200 bg-cream-50 text-stone-500 hover:border-sand-300 hover:text-ink";
        });
        btn.setAttribute("aria-pressed", "true");
        btn.className = "filter-tab rounded-full border px-5 py-2 text-sm font-semibold transition-colors duration-200 border-gold-deep bg-gold-deep text-cream-50";
        draw(btn.getAttribute("data-filter"));
      });
    }

    // honor ?kategori= deep link
    var params = new URLSearchParams(location.search);
    var initial = params.get("kategori");
    if (initial && CATS[initial]) {
      draw(initial);
      var t = bar && bar.querySelector('[data-filter="' + initial + '"]');
      if (t) t.click();
    } else {
      draw("all");
    }
  }

  // ---- Çiftlikten Sofraya: origin map + proof stats ----
  // Gerçek Türkiye silüeti — coğrafi koordinatlardan kalibre edilmiştir.
  // viewBox 0 0 1000 460. Lon 26°→x=60, 45°→x=950; Lat 42°→y=145, 36°→y=370.
  var TR_PATH =
    "M83,156 L110,150 L135,147 L175,156 L215,160 L260,168 L313,170 L355,158 " +
    "L425,148 L488,144 L523,164 L543,170 L588,178 L615,183 L639,186 L670,184 " +
    "L700,183 L737,182 L765,170 L785,162 L795,168 L810,176 L839,179 L857,181 " +
    "L880,200 L901,223 L915,250 L923,280 L920,308 L905,318 L885,318 L850,317 " +
    "L831,320 L800,325 L771,330 L749,321 L720,330 L685,338 L666,344 L635,338 " +
    "L621,332 L605,331 L594,330 L582,343 L568,355 L555,363 L545,361 L539,360 " +
    "L530,348 L537,344 L527,341 L510,344 L501,350 L485,344 L467,340 L445,348 " +
    "L425,355 L405,365 L385,369 L365,360 L347,350 L322,345 L295,340 L278,338 " +
    "L255,355 L228,361 L215,348 L195,345 L176,339 L156,343 L134,345 L120,338 " +
    "L137,333 L122,322 L110,312 L129,302 L110,290 L95,278 L85,284 L78,265 " +
    "L94,272 L88,250 L103,246 L92,232 L73,226 L70,210 L80,200 L71,194 L75,180 " +
    "L95,182 L105,170 L100,162 L83,156 Z";

  function renderOrigins() {
    var hosts = document.querySelectorAll("#origin-map, .origin-map");
    if (!hosts.length) return;
    var origins = window.FREYA_ORIGINS || [];
    var proof = window.FREYA_PROOF || [];

    var pins = origins
      .map(function (o, i) {
        var d = (i * 70) % 700;
        return (
          '<g class="origin-pin" style="--d:' + d + 'ms" tabindex="0" role="listitem" ' +
          'aria-label="' + esc(o.region) + " — " + esc(o.item) + '">' +
          '<line x1="' + o.x + '" y1="' + o.y + '" x2="' + o.x + '" y2="' + (o.y - 26) + '" stroke="#A9711B" stroke-width="2"/>' +
          '<circle class="origin-dot" cx="' + o.x + '" cy="' + o.y + '" r="6" fill="#A9711B"/>' +
          '<circle class="origin-ping" cx="' + o.x + '" cy="' + o.y + '" r="6" fill="none" stroke="#A9711B" stroke-width="2"/>' +
          '<circle cx="' + o.x + '" cy="' + (o.y - 30) + '" r="4" fill="#8A5A14"/>' +
          // hover/focus tooltip
          '<g class="origin-tip" transform="translate(' + o.x + "," + (o.y - 30) + ')">' +
          '<rect x="-90" y="-58" width="180" height="46" rx="8" fill="#2A211B"/>' +
          '<text x="0" y="-38" text-anchor="middle" fill="#FBF7F0" font-size="15" font-weight="600" font-family="Inter,sans-serif">' + esc(o.region) + "</text>" +
          '<text x="0" y="-20" text-anchor="middle" fill="#E1CFB2" font-size="12" font-family="Inter,sans-serif">' + esc(o.item) + "</text>" +
          "</g></g>"
        );
      })
      .join("");

    var legend = origins
      .map(function (o, i) {
        return (
          '<li class="reveal flex items-start gap-3" style="transition-delay:' + (i % 5) * 60 + 'ms">' +
          '<span class="mt-1.5 h-2 w-2 shrink-0 rounded-full bg-gold"></span>' +
          "<div><p class=\"font-semibold text-ink\">" + esc(o.region) + "</p>" +
          '<p class="text-sm text-stone-500">' + esc(o.item) + " · " + esc(o.note) + "</p></div></li>"
        );
      })
      .join("");

    var stats = proof
      .map(function (s, i) {
        return (
          '<div class="reveal text-center" style="transition-delay:' + i * 80 + 'ms">' +
          '<p class="font-display text-display-lg font-semibold text-gold-deep">' + esc(s.value) + "</p>" +
          '<p class="mt-1 text-sm font-semibold text-ink">' + esc(s.label) + "</p>" +
          '<p class="text-xs text-stone-400">' + esc(s.sub) + "</p></div>"
        );
      })
      .join("");

    var html =
      '<div class="grid items-center gap-10 lg:grid-cols-[1.15fr_0.85fr] lg:gap-14">' +
      // map
      '<div class="reveal relative">' +
      '<svg viewBox="0 0 1000 460" class="tr-map tr-map-shadow" role="list" aria-label="Tedarik haritası" xmlns="http://www.w3.org/2000/svg">' +
      '<defs>' +
        '<linearGradient id="tr-gradient" x1="0%" y1="0%" x2="0%" y2="100%">' +
          '<stop offset="0%" stop-color="#F5ECD9"/>' +
          '<stop offset="55%" stop-color="#EFE0BE"/>' +
          '<stop offset="100%" stop-color="#E4CD96"/>' +
        '</linearGradient>' +
        '<pattern id="tr-grain" x="0" y="0" width="6" height="6" patternUnits="userSpaceOnUse">' +
          '<circle cx="1" cy="1" r="0.4" fill="#B89265" opacity="0.18"/>' +
        '</pattern>' +
      '</defs>' +
      // Watermark logo
      '<image href="https://cdn.shopify.com/s/files/1/0753/6610/5372/files/freya-2026-images-freya-logo.webp?v=1790406311" x="350" y="180" width="320" height="320" class="tr-map__watermark" preserveAspectRatio="xMidYMid meet"/>' +
      // Land
      '<path d="' + TR_PATH + '" class="tr-map__land"/>' +
      '<path d="' + TR_PATH + '" fill="url(#tr-grain)" stroke="none"/>' +
      // Sea labels
      '<text x="500" y="115" text-anchor="middle" class="tr-map__sea-label" font-size="14">KARADENİZ</text>' +
      '<text x="40" y="290" class="tr-map__sea-label" font-size="11" transform="rotate(-90 40 290)">EGE DENİZİ</text>' +
      '<text x="430" y="430" text-anchor="middle" class="tr-map__sea-label" font-size="13">AKDENİZ</text>' +
      // Cyprus hint (lightly)
      '<ellipse cx="455" cy="412" rx="22" ry="6" fill="#EFE0BE" opacity="0.55" stroke="#D4B98A" stroke-width="0.6"/>' +
      pins +
      "</svg>" +
      '<p class="mt-3 text-center text-xs text-stone-400">Gerçek tedarik yöreleri — kaynak: Freya bahçeleri ve seçili çiftçilerimiz</p>' +
      "</div>" +
      // legend
      '<div><ul class="grid grid-cols-1 gap-x-6 gap-y-4 sm:grid-cols-2 lg:grid-cols-1">' + legend + "</ul></div>" +
      "</div>" +
      // proof band
      '<div class="mt-16 grid grid-cols-2 gap-8 border-t border-cream-200 pt-12 md:grid-cols-4">' + stats + "</div>";
    hosts.forEach(function (h) { h.innerHTML = html; });
  }

  // ============================================================
  //  TARİFLER (recipes)
  // ============================================================
  var R = window.FREYA_RECIPES || [];
  var RCATS = window.FREYA_RECIPE_CATS || {};

  function recipeProduct(r) {
    return P.find(function (p) { return p.slug === r.productSlug; });
  }

  // Art-directed recipe visual: reuses the linked product's hue + a photo
  // probe at images/recipes/{slug}.(jpg|png|webp).
  function recipeVisual(r, opts) {
    opts = opts || {};
    var prod = recipeProduct(r);
    var h = (prod && prod.hue) || ["#B98A3E", "#7A4F12"];
    var icon = opts.big ? 3.4 : 2.2;
    return (
      '<div class="pv h-full w-full" style="background:radial-gradient(120% 90% at 50% 0%, ' +
      h[0] + " 0%, " + h[1] + ' 82%)">' +
      '<span class="pv__bloom"></span>' +
      '<div class="pv__jar"><span class="pv__mono" style="font-size:' + icon + 'rem">✦</span>' +
      '<span class="pv__tag">Freya Tarif</span></div>' +
      '<span class="pv__grain"></span>' +
      '<img class="pv__photo" alt="' + esc(r.title) + '" loading="lazy" data-photo="images/recipes/' + r.slug + '">' +
      "</div>"
    );
  }

  function recipeMeta(r) {
    var bits = [];
    if (r.time) bits.push(r.time);
    if (r.serves) bits.push(r.serves);
    return bits.join(" · ");
  }

  function recipeCard(r) {
    var rc = RCATS[r.cat] || { label: "" };
    var prod = recipeProduct(r);
    var pcolor = (prod && CATS[prod.cat] && CATS[prod.cat].color) || "#9A5F1C";
    return (
      '<article class="product-card group flex flex-col overflow-hidden rounded-lg border border-cream-200 bg-cream-50 shadow-soft transition-all duration-300 hover:-translate-y-1 hover:shadow-card" ' +
      'data-recipe="' + r.slug + '" data-rcat="' + r.cat + '">' +
      '<button type="button" class="js-ropen relative block aspect-[4/3] w-full overflow-hidden text-left" aria-label="' + esc(r.title) + ' tarifi">' +
      '<span class="block h-full w-full transition-transform duration-500 ease-entrance group-hover:scale-[1.04]">' +
      recipeVisual(r) + "</span>" +
      '<span class="absolute left-3 top-3 rounded-full bg-cream-50/95 px-3 py-1 text-[0.68rem] font-semibold uppercase tracking-[0.08em] text-ink shadow-soft">' + esc(rc.label) + "</span>" +
      "</button>" +
      '<div class="flex flex-1 flex-col p-5">' +
      '<span class="inline-flex w-fit items-center gap-1.5 text-[0.7rem] font-semibold uppercase tracking-[0.06em]" style="color:' + pcolor + '">' +
      '<span class="h-1.5 w-1.5 rounded-full" style="background:' + pcolor + '"></span>' + esc(r.product || "") + "</span>" +
      '<h3 class="mt-2 font-display text-h3 font-semibold text-ink">' + esc(r.title) + "</h3>" +
      (p.sizes ? '<p class="product-sizes">' + esc(p.sizes) + '</p>' : '') +
      '<p class="mt-2 flex-1 text-sm leading-relaxed text-stone-500">' + esc(r.summary || "") + "</p>" +
      (recipeMeta(r) ? '<p class="mt-4 text-xs font-medium uppercase tracking-[0.08em] text-stone-400">' + esc(recipeMeta(r)) + "</p>" : "") +
      '<button type="button" class="js-ropen mt-4 inline-flex w-fit items-center gap-1.5 text-sm font-semibold text-gold-deep transition-colors hover:text-gold-dark">Tarifi Gör' +
      '<svg class="h-3.5 w-3.5" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="2"><path d="M7 5l5 5-5 5" stroke-linecap="round" stroke-linejoin="round"/></svg></button>' +
      "</div></article>"
    );
  }

  function openRecipe(slug) {
    var r = R.find(function (x) { return x.slug === slug; });
    if (!r) return;
    var rc = RCATS[r.cat] || { label: "" };
    var prod = recipeProduct(r);
    var pslug = prod ? prod.slug : null;
    var hasFull = r.ingredients && r.steps;
    previousFocus = document.activeElement;
    ensureModal();
    var panel = document.getElementById("pmodal-panel");

    var ing = hasFull
      ? '<div class="mt-6"><p class="text-label font-semibold uppercase tracking-[0.12em] text-gold-deep">Malzemeler</p>' +
        '<ul class="mt-3 space-y-2">' +
        r.ingredients.map(function (x) {
          return '<li class="flex items-start gap-2.5 text-sm text-stone-600"><span class="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-gold"></span>' + esc(x) + "</li>";
        }).join("") + "</ul></div>"
      : "";

    var stp = hasFull
      ? '<div class="mt-6"><p class="text-label font-semibold uppercase tracking-[0.12em] text-gold-deep">Hazırlanışı</p>' +
        '<ol class="mt-3 space-y-3">' +
        r.steps.map(function (x, i) {
          return '<li class="flex gap-3 text-sm leading-relaxed text-stone-600">' +
            '<span class="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-gold/12 font-display text-sm font-semibold text-gold-deep">' + (i + 1) + "</span>" +
            "<span class=\"pt-0.5\">" + esc(x) + "</span></li>";
        }).join("") + "</ol></div>"
      : '<p class="mt-6 rounded-lg border border-cream-200 bg-cream-100/60 p-4 text-sm leading-relaxed text-stone-500">Bu tarifin tüm adımlarını yakında burada paylaşacağız. Dilediğiniz malzemelerle evinizde kolaylıkla deneyebilirsiniz.</p>';

    var meta = recipeMeta(r);
    var prodLink = prod
      ? '<a href="/collections/all#" data-jump="' + pslug + '" class="js-prodjump mt-7 inline-flex w-full items-center justify-center gap-2 rounded-md bg-gold px-6 py-3.5 text-base font-semibold text-cream-50 transition-colors duration-200 hover:bg-gold-deep">' +
        esc(r.product) + " ürününü gör</a>"
      : "";

    panel.innerHTML =
      '<button type="button" id="pmodal-close" aria-label="Kapat" class="absolute right-3 top-3 z-10 flex h-10 w-10 items-center justify-center rounded-full bg-cream-50/90 text-ink shadow-soft transition hover:bg-cream-100">' +
      '<svg class="h-5 w-5" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="2"><path d="M5 5l10 10M15 5L5 15" stroke-linecap="round"/></svg></button>' +
      '<div class="relative aspect-[16/9] w-full overflow-hidden md:aspect-[2/1]">' + recipeVisual(r, { big: true }) + "</div>" +
      '<div class="p-7 md:p-9">' +
      '<span class="inline-block rounded-full bg-cream-100 px-3 py-1 text-[0.68rem] font-semibold uppercase tracking-[0.08em] text-stone-600">' + esc(rc.label) + "</span>" +
      '<h2 class="mt-4 font-display text-h1 font-semibold text-ink">' + esc(r.title) + "</h2>" +
      (meta ? '<p class="mt-2 text-sm font-medium uppercase tracking-[0.08em] text-stone-400">' + esc(meta) + "</p>" : "") +
      '<p class="mt-4 text-base leading-relaxed text-stone-600">' + esc(r.summary || "") + "</p>" +
      ing + stp + prodLink +
      "</div>";

    bindVariants(p, panel);
    document.getElementById("pmodal-close").addEventListener("click", close);
    var jump = panel.querySelector(".js-prodjump");
    if (jump) {
      jump.addEventListener("click", function (e) {
        // let the link navigate; product page can read the hash if desired
      });
    }
    modal.classList.remove("hidden");
    modal.classList.add("flex");
    document.body.style.overflow = "hidden";
    document.querySelectorAll("#site-header,#main,#site-footer,#wa-fab,.freya-service-footer").forEach(function(el){el.inert=true;});
    var sc = document.getElementById("pmodal-panel");
    if (sc) sc.scrollTop = 0;
    swapPhotos(panel);
    document.getElementById("pmodal-close").focus();
  }

  function bindRecipeClicks(root) {
    root.querySelectorAll("[data-recipe]").forEach(function (el) {
      var slug = el.getAttribute("data-recipe");
      el.querySelectorAll(".js-ropen").forEach(function (btn) {
        btn.addEventListener("click", function () { openRecipe(slug); });
      });
    });
  }

  function renderRecipeFeatured() {
    var host = document.getElementById("recipe-featured");
    if (!host) return;
    var picks = ["carkifelek-somon-ceviche", "cilek-jalepeno-soslu-quesadillas", "maviyemis-lavanta-soslu-saglikli-dondurma"]
      .map(function (s) { return R.find(function (r) { return r.slug === s; }); })
      .filter(Boolean);
    host.innerHTML = picks
      .map(function (r, i) {
        return '<div class="reveal" style="transition-delay:' + i * 90 + 'ms">' + recipeCard(r) + "</div>";
      })
      .join("");
    bindRecipeClicks(host);
    swapPhotos(host);
  }

  function renderRecipes() {
    var host = document.getElementById("recipe-grid");
    if (!host) return;

    function draw(filter) {
      var list = filter === "all" ? R : R.filter(function (r) { return r.cat === filter; });
      host.innerHTML = list
        .map(function (r, i) {
          return '<div class="reveal is-visible" style="transition-delay:' + (i % 3) * 70 + 'ms">' + recipeCard(r) + "</div>";
        })
        .join("");
      bindRecipeClicks(host);
      swapPhotos(host);
      var countEl = document.getElementById("recipe-count");
      if (countEl) countEl.textContent = list.length + " tarif";
    }

    var bar = document.getElementById("recipe-filters");
    if (bar) {
      var tabs = [{ key: "all", label: "Tümü" }].concat(
        Object.keys(RCATS).map(function (k) { return { key: k, label: RCATS[k].label }; })
      );
      bar.innerHTML = tabs
        .map(function (t, i) {
          var active = i === 0;
          return (
            '<button type="button" role="tab" data-rfilter="' + t.key + '" aria-selected="' + active + '" ' +
            'class="rfilter-tab rounded-full border px-5 py-2 text-sm font-semibold transition-colors duration-200 ' +
            (active ? "border-gold-deep bg-gold-deep text-cream-50" : "border-cream-200 bg-cream-50 text-stone-500 hover:border-sand-300 hover:text-ink") +
            '">' + t.label + "</button>"
          );
        })
        .join("");
      bar.addEventListener("click", function (e) {
        var btn = e.target.closest(".rfilter-tab");
        if (!btn) return;
        bar.querySelectorAll(".rfilter-tab").forEach(function (b) {
          b.setAttribute("aria-selected", "false");
          b.className = "rfilter-tab rounded-full border px-5 py-2 text-sm font-semibold transition-colors duration-200 border-cream-200 bg-cream-50 text-stone-500 hover:border-sand-300 hover:text-ink";
        });
        btn.setAttribute("aria-selected", "true");
        btn.className = "rfilter-tab rounded-full border px-5 py-2 text-sm font-semibold transition-colors duration-200 border-gold-deep bg-gold-deep text-cream-50";
        draw(btn.getAttribute("data-rfilter"));
      });
    }

    var params = new URLSearchParams(location.search);
    var initial = params.get("kategori");
    if (initial && RCATS[initial]) {
      draw(initial);
      var t = bar && bar.querySelector('[data-rfilter="' + initial + '"]');
      if (t) t.click();
    } else {
      draw("all");
    }
  }

  window.FREYA_PRODUCT_GALLERY = function(p){ return gallery(p,{big:true}); };
  window.FREYA_INIT_GALLERY = swapPhotos;
  window.FREYA_RENDER = function () {
    swapPhotos(document);
    renderFeatured();
    renderCatalog();
    renderOrigins();
    renderRecipeFeatured();
    renderRecipes();
    if (document.getElementById("catalog-grid")) {
      openDetail(decodeURIComponent(location.hash.slice(1)));
      window.addEventListener("hashchange", function () { openDetail(decodeURIComponent(location.hash.slice(1))); });
    }
  };
})();
